/** @jsx jsx */

import { FC } from 'react';
import { jsx } from '@emotion/core';
import { useSelector } from 'react-redux';

import { Disclosure } from 'state/tenant';

import { getDisclosureUrl, selectTenant } from 'state/tenant';

import styles from './styles';

interface PropTypes {
  type: Disclosure['type'];
  className?: string;
}

const DisclosureBox: FC<PropTypes> = ({ type, className }) => {
  const tenant = useSelector(selectTenant);
  const url = getDisclosureUrl(tenant, type);

  return (
    <div css={styles.termsContainer} className={className}>
      <iframe
        css={styles.terms}
        title="Terms"
        src={url}
        data-cy="disclosureBox"
      />
    </div>
  );
};

export default DisclosureBox;
